export enum MobileMenuComponentType {
    CHAT = 'Chat',
    CHAPTER = 'Chapter',
    PARTICIPANTS = 'Participants',
    POLLS = 'Polls',
    SLIDES = 'Slides',
    VIDEO = 'Video'
}
